var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPins(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 4.99985V11.9999L17.7 13.6999C17.8 13.7999 17.875 13.9124 17.925 14.0374C17.975 14.1624 18 14.2915 18 14.4249V14.9999C18 15.2832 17.9042 15.5207 17.7125 15.7124C17.5208 15.904 17.2833 15.9999 17 15.9999H13V21.8499C13 22.1332 12.9042 22.3707 12.7125 22.5624C12.5208 22.754 12.2833 22.8499 12 22.8499C11.7167 22.8499 11.4792 22.754 11.2875 22.5624C11.0958 22.3707 11 22.1332 11 21.8499V15.9999H7C6.71667 15.9999 6.47917 15.904 6.2875 15.7124C6.09583 15.5207 6 15.2832 6 14.9999V14.4249C6 14.2915 6.025 14.1624 6.075 14.0374C6.125 13.9124 6.2 13.7999 6.3 13.6999L8 11.9999V4.99985C7.71667 4.99985 7.47917 4.90402 7.2875 4.71235C7.09583 4.52069 7 4.28319 7 3.99985C7 3.71652 7.09583 3.47902 7.2875 3.28735C7.47917 3.09569 7.71667 2.99985 8 2.99985H16C16.2833 2.99985 16.5208 3.09569 16.7125 3.28735C16.9042 3.47902 17 3.71652 17 3.99985C17 4.28319 16.9042 4.52069 16.7125 4.71235C16.5208 4.90402 16.2833 4.99985 16 4.99985ZM8.85 13.9999H15.15L14 12.8499V4.99985H10V12.8499L8.85 13.9999Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPins);
export default __webpack_public_path__ + "static/media/Pins.927bea3f.svg";
export { ForwardRef as ReactComponent };